module.exports = __webpack_public_path__ + "static/media/phone_paused-24px.84161f8e.svg";